/* eslint-disable prefer-template */
/* eslint-disable curly */
/* eslint-disable no-else-return */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable consistent-return */
/* eslint-disable import/extensions */
/* eslint-disable react/no-danger */
/* eslint-disable no-use-before-define */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React from 'react';
import { SALESGEAR_URL } from 'Utils/constants';
import ContactUploadErrorIcon from 'Assets/salesgear/png/contactUploadError.png';
import Button from '../../common/Button';

const BulkPopupMessage = props => {
  const { errorDetails, showSkipContacts, closePopup } = props;

  const getMessage = () => {
    if (errorDetails && Object.keys(errorDetails).length) {
      const {
        missingFields,
        validCount,
        uploadedCount,
      } = errorDetails;

      if (validCount === 0 && uploadedCount > 0) {
        return constructAllFieldsMissingDom(missingFields, uploadedCount);
      } else {
        return partialiFieldsMissingDom(
          uploadedCount,
          validCount,
          missingFields,
        );
      }
    }
  };

  const constructAllFieldsMissingDom = (
    missingFields = [],
    uploadedCount = 0,
  ) => {
    const missingFieldsLen = missingFields?.length;
    const contactText = uploadedCount > 1 ? 'contacts' : 'contact';
    const fieldText = missingFieldsLen > 1 ? 'fields are' : 'field is';
    return (
      <div className="allFieldsMissingCont">
        <div className="messageCont">
          <div className="message">
            Sorry, we cannot add the selected {contactText} to the sequence as
            the following mandatory {fieldText} missing
          </div>
          {getMissingFieldsDom(missingFields)}
        </div>
      </div>
    );
  };

  const getMissingFieldsDom = (missingFields = []) => {
    const missingFieldsLen = missingFields?.length;
    return (
      <div className="missingFieldsCont">
        {missingFields &&
          missingFields.map((value, index) => {
            return (
              <span key={`missingField ${index}`} className="missingField">
                {missingFieldsLen > 1 && (
                  <span className="indexValue"> {index + 1}.&nbsp;</span>
                )}
                <span className="value">{value}</span>
                {index + 1 !== missingFieldsLen ? (
                  <span className="delimitter">|</span>
                ) : (
                  ''
                )}
              </span>
            );
          })}
      </div>
    );
  };

  const partialiFieldsMissingDom = (
    uploadedCount = 0,
    validCount = 0,
    missingFields = [],
  ) => {
    const missingFieldsLen = missingFields?.length || 0;
    const contactsText = uploadedCount > 1 ? 'contacts' : 'contact';
    const fieldText = missingFieldsLen > 1 ? 'fields' : 'field';
    const invalidContactCount = Math.abs(uploadedCount - validCount);
    return (
      <div className="partialFieldsMissingCont">
        <div className="messageCont">
          <div className="message">
            You have &nbsp;
            <b>
              selected {uploadedCount} {contactsText}
            </b>{' '}
            and <b>{invalidContactCount} of them </b>
            don't have the following mandatory {fieldText}
          </div>
          {getMissingFieldsDom(missingFields)}
        </div>
      </div>
    );
  };

  const getSkipContactBtn = () => {
    const skipAndUpload = () => {
      const { cbk, validContactIds } = errorDetails;
      cbk(validContactIds);
    };

    return (
      <div className="btnCont">
        <Button
          id="cancel"
          name="cancel"
          type="button"
          className="btnTheme"
          btnText="Cancel"
          loader={false}
          click={e => {
            closePopup();
          }}
        />
        <Button
          id="skipAndUploadContact"
          name="skipAndUploadContact"
          type="button"
          className="btnTheme"
          btnText="Skip the contacts with missing fields and proceed"
          loader={false}
          click={e => {
            skipAndUpload(e);
          }}
        />
      </div>
    );
  };

  const getOkBtn = () => {
    return (
      <div className="btnCont">
        <Button
          id="okBtn"
          name="okBtn"
          type="button"
          className="btnTheme"
          btnText="Ok"
          loader={false}
          click={e => {
            closePopup();
          }}
        />
      </div>
    );
  };

  return (
    <div className="bulkPopupMessage">
      <div className="imageCont">
        <img src={ContactUploadErrorIcon} alt="" className="contactErrorIcon" />
      </div>
      <div className="errorMessage">{getMessage()}</div>
      {errorDetails && (
        <div className="bottomCont">
          {showSkipContacts ? getSkipContactBtn() : getOkBtn()}
        </div>
      )}
    </div>
  );
};

export { BulkPopupMessage };
export default BulkPopupMessage;
